import React from 'react';
import CirclePlus from '@uber/base-icons/circle-plus';
import { useStyletron } from 'baseui';
import { ICON_SIZE } from '../constants';
import type { ActionButtonPropsT } from '../types';
import { ActionButton } from './action-button';
export function ObjectInstantiationButton({
  onClick
}: ActionButtonPropsT) {
  const [, theme] = useStyletron();
  return <ActionButton icon={<CirclePlus size={ICON_SIZE} color={theme.colors.contentPrimary} />} name="Object Instantiation" onClick={onClick} tooltipContent="Copy Instance" />;
}